import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFilterTextFieldValue, isDetailsPage } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

import { _getKey } from '@utils/Util';

const Search = ({ placeholder, identifier = 'name', isHideChip = false }) => {
	const getFilterData = (store) =>
		isDetailsPage() ? store.filterFieldStore?.DETAILS_PAGE_FILTERS : store.filterFieldStore;
	const filterData = useSelector((store) => getFilterData(store));
	const inputValue = getFilterTextFieldValue(filterData, identifier, identifier);
	const [debouncedValue, setDebouncedValue] = useState('');
	const [isSearchOpen, setIsSearchOpen] = useState(false);
	const [, setReload] = useState('');
	const isFirstRender = useRef(true);
	const textInputRef = useRef('');
	const dispatch = useDispatch();

	useEffect(() => {
		if (inputValue === undefined) {
			textInputRef.current = '';
			setDebouncedValue('');
			setReload(_getKey());
		}
	}, [inputValue]);

	const handleChange = (e) => {
		const { value } = e.target;
		setDebouncedValue(value);
		textInputRef.current = value;
	};

	useEffect(() => {
		if (!isFirstRender.current) {
			const debounceTimer = setTimeout(() => {
				let data = {
					name: identifier,
					type: 'text',
					key: debouncedValue,
					value: debouncedValue,
					identifier: identifier,
					isHideChip
				};
				dispatch(updateTextItemInGlobalFilter(data));
			}, 500);
			return () => {
				clearTimeout(debounceTimer);
			};
		} else {
			textInputRef.current = inputValue?.value || '';
			isFirstRender.current = false;
		}
	}, [debouncedValue]);

	return (
		<div className="form-group size32 m-0 search-filter filter-with-animation">
			<div className={`${isSearchOpen ? 'with-icon right-icon' : 'with-icon right-icon'}`}>
				<input
					type="text"
					placeholder={placeholder}
					name="name"
					value={textInputRef.current}
					onChange={handleChange}
					autoFocus={window.innerWidth >= 768}
					autoComplete="off"
				/>
				<span className="right-icon" onClick={() => setIsSearchOpen((prev) => !prev)}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width={23}
						height={22}
						viewBox="0 0 23 22"
						fill="none"
					>
						<path
							d="M10.543 16.5C14.3399 16.5 17.418 13.422 17.418 9.625C17.418 5.82804 14.3399 2.75 10.543 2.75C6.74601 2.75 3.66797 5.82804 3.66797 9.625C3.66797 13.422 6.74601 16.5 10.543 16.5Z"
							stroke="#21242B"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M19.2526 18.3346L15.5859 14.668"
							stroke="#21242B"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</span>
			</div>
		</div>
	);
};

export default Search;
